import React, { useState } from 'react';
import styled from 'styled-components';
import { GlassCard } from '../styles/GlobalStyles';
import FootballClubLogo from './FootballClubLogo';
import MasMediaLogo from './MasMediaLogo';
import SubscriptionModal from './SubscriptionModal';
import LaLigaLogo from './LaLigaLogo';

const PricingContainer = styled.div.attrs({
  className: 'pricing-container'
})`
  display: flex;
  justify-content: flex-start;
  padding: 20px;
  
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

const StyledPricingCard = styled(GlassCard).attrs({
  className: 'pricing-card'
})`
  padding: 30px;
  text-align: center;
  width: 100%;
  max-width: 500px;
  
  @media (max-width: 768px) {
    max-width: 380px;
    padding: 25px;
  }
  
  @media (max-width: 480px) {
    max-width: 310px;
    padding: 20px;
  }
`;

const PriceWithLabel = styled.div.attrs({
  className: 'price-with-label'
})`
  font-family: 'CocomatPro', sans-serif;
  font-size: 21px;
  font-weight: bold;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 1;
  display: flex;
  align-items: center;
  
  .price-amount {
    font-size: 86px;
    margin-left: 10px;
    
  }
  
  .currency {
    font-size: 60px;
    vertical-align: top;
  }
  
  @media (max-width: 768px) {
    font-size: 18px;
    
    .price-amount {
      font-size: 70px;
    }
    
    .currency {
      font-size: 50px;
    }
  }
  
  @media (max-width: 480px) {
    flex-direction: column;
  
    .price-amount {
      font-size: 60px;
    }
    
    .currency {
      font-size: 40px;
    }
  }
`;

const PriceContainer = styled.div.attrs({
  className: 'price-container'
})`
  position: relative;
  margin-bottom: 30px;
`;

const Duration = styled.div.attrs({
  className: 'duration'
})`
  font-family: 'CocomatPro', sans-serif;
  font-size: 21px;
  opacity: 0.7;
  text-align: right;
  margin-top: -10px;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const PackageTitle = styled.h3.attrs({
  className: 'package-title'
})`
  font-family: 'CocomatPro', sans-serif;
  font-size: 35.5px;
  margin: 15px 0 10px 0;
  font-weight: normal;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  
  .highlight {
    color: #fcce00;
    font-weight: bold;
  }
  
  @media (max-width: 768px) {
    font-size: 25px;
    gap: 8px;
  }
  
  @media (max-width: 480px) {
    gap: 6px;
  }
`;

const Platform = styled.div.attrs({
  className: 'platform'
})`
  font-family: 'Inter', sans-serif;
  font-size: 26px;
  opacity: 0.8;
  margin-bottom: 25px;
  display: flex;
  gap: 10px;
  align-items: center;
  color: #FFF;
  opacity: 1;
  
  .brand {
    color: #00bcd4;
    font-weight: bold;
  }
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
  
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const PlatformPackage = styled.div.attrs({
  className: 'platform-package'
})`
  font-size: 16px;
  opacity: 0.8;
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  color: #FFF;
  opacity: 1;
  
  img {
    height: 20px;
  }
    
  @media (max-width: 768px) {
    font-size: 18px;
  }
  
`;
const ActionButton = styled.button`
  font-family: 'CocomatPro', sans-serif;
  background: linear-gradient(100deg, #fcce00, #f7931e);
  border: none;
  border-radius: 25px;
  padding: 15px 35px;
  color: white;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-transform: uppercase;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);

  letter-spacing: 1px;
  margin-bottom: 20px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
  }
  
  @media (max-width: 768px) {
    padding: 12px 30px;
    font-size: 14px;
  }
`;

const PromoText = styled.div.attrs({
  className: 'promo-text'
})`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  opacity: 0.6;
  margin-top: 15px;
  line-height: 1.3;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
`;

const PricingCardComponent: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubscribeClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <PricingContainer>
        <StyledPricingCard>
          <PriceContainer>
            <PriceWithLabel>
              <span className="price-label">POR SOLO </span><span className="price-amount">49,99€</span>
            </PriceWithLabel>
            <Duration>/temporada</Duration>
          </PriceContainer>
          
          <ActionButton onClick={handleSubscribeClick}>
            ¡COMPRAR AHORA!
          </ActionButton>
          
          <PackageTitle>
            <strong>PACK</strong> <MasMediaLogo />
          </PackageTitle>
          <PlatformPackage>
            <strong>CON 90 CANALES, INCLUIDA</strong><LaLigaLogo />
          </PlatformPackage>
          <Platform>
            <strong>EN</strong><FootballClubLogo />
          </Platform>
          <PromoText>
            * Promoción válida hasta el 24 de Agosto de 2025
          </PromoText>
          <PromoText>
            ** Recibirás el mail con tus nuevas credenciales en un plazo de 24/48 horas tras la compra
          </PromoText>
        </StyledPricingCard>
      </PricingContainer>
      
      <SubscriptionModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default PricingCardComponent;